module.exports = __webpack_public_path__ + "static/media/trainVideo12.3f1fcbcc.mp4";